import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import LoaderButton from '../LoaderButton/LoaderButton';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const NewPasswordModal = ({ t, }) => {
  const classes = useStyles();
  const [redirect, setredirect] = useState(false);
  if (redirect) {
    window.location = '/dashboard/auth/sign-in';
  }
  return (
    <div className={classes.newPasswordMoal}>
      <h3> {t('email_sent')} </h3>
      <div className={classes.buttonContainer}>
        <LoaderButton label={t('ok')} onClick={() => setredirect(true)} />
      </div>
    </div>
  );
};

NewPasswordModal.propTypes = {
  t: PropTypes.func.isRequired,
};

const useStyles = createUseStyles({
  newPasswordMoal: {
    backgroundColor: 'white',
    width: '100%',
    maxWidth: '600px',
    borderRadius: '4px',
    padding: '2em 1em',
    '& h3': {
      color: ' #54515A',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});


export default withScopedTranslations('signIn')(NewPasswordModal);

